"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SMBAccountModalState = /** @class */ (function () {
    function SMBAccountModalState() {
        this.showModal = true;
    }
    return SMBAccountModalState;
}());
exports.default = SMBAccountModalState;
//# sourceMappingURL=SMBAccountModalState.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/components/panels/Passcode/SMBAccountModal/SMBAccountModalState.js
// module id = 1671
// module chunks = 8